// @flow

import React from 'react';
import { Box, Icon, Text, Touchable } from 'gestalt';

const ICON_BUTTON_SIZE = 70;
const ICON_SIZE = 40;

type Props = {|
  accessibilityLabel: string,
  iconBackgroundColor: 'green' | 'white',
  iconColor: 'blue' | 'white',
  iconType: 'check' | 'ellipsis' | 'globe' | 'pin',
  onClickHander: () => void,
  text: string,
  widthInColumn: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
|};

function CreatorChecklistAction(props: Props) {
  const {
    accessibilityLabel,
    iconType,
    iconBackgroundColor,
    iconColor,
    onClickHander,
    text,
    widthInColumn,
  } = props;

  return (
    <Box column={widthInColumn} display="flex" justifyContent="center" minWidth={248}>
      <Touchable onTouch={onClickHander}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box
            color={iconBackgroundColor}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={ICON_BUTTON_SIZE}
            height={ICON_BUTTON_SIZE}
            shape="circle"
          >
            <Icon
              accessibilityLabel={accessibilityLabel}
              color={iconColor}
              icon={iconType}
              size={ICON_SIZE}
            />
          </Box>
          <Box display="inlineBlock" marginLeft={2}>
            <Text inline size="xl">
              {text}
            </Text>
          </Box>
        </Box>
      </Touchable>
    </Box>
  );
}

export default CreatorChecklistAction;
